import type { FC, ReactNode } from 'react'

import { ArrowRight } from 'lucide-react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { arrowClass, buttonClass } from '@/components/generals/button'
import QuoteLink from '@/components/generals/quote-link'
import ProjectCard from '@/components/landing/project-card'
import { quoteLabel, work } from '@/constants/content'

const WorkPage: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Work'
                description={`${work.intro} Websites by David Mudry, web developer in Fort Worth, TX.`}
            />

            <section className='bg-ink pb-24 pt-32 text-paper [--focus-ring:var(--paper)] sm:pb-32 sm:pt-40'>
                <div className='shell'>
                    <h1 className='font-heading text-[18vw] font-extrabold leading-[0.86] tracking-[-0.045em] wdth-78 sm:text-[13vw] lg:text-[10rem]'>
                        {work.heading}
                    </h1>

                    <p className='mt-8 max-w-[34rem] text-xl leading-relaxed text-paper/80 sm:text-2xl'>
                        {work.intro}
                    </p>

                    <div className='mt-16 grid gap-16 sm:mt-24 lg:grid-cols-2 lg:gap-x-12 lg:gap-y-24'>
                        {work.projects.map((project, index) => (
                            <ProjectCard
                                key={project.slug}
                                project={project}
                                index={index}
                                headingLevel='h2'
                                className={index % 2 === 1 ? 'lg:mt-32' : undefined}
                            />
                        ))}
                    </div>

                    <div className='mt-24 flex justify-center'>
                        <QuoteLink className={buttonClass({ size: 'lg', shadow: 'paper', className: 'border-paper' })}>
                            {quoteLabel}
                            <ArrowRight aria-hidden='true' className={arrowClass} />
                        </QuoteLink>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default WorkPage
